export default "__VITE_ASSET__DnuHRah$__"